import ProductDescription from './ProductDescription'

const CheeseProduct = {
  ...ProductDescription,
  category: '02',
  subCategory: '001',
  IsBroadband: false,
  FatLevel: '',
  Type: '',
  Size: '16 ounces only',
  MadeInUSA: false,
  Kosher: false,
}

export default CheeseProduct
